export enum ModalType {
  NONE = 'NONE',
  VERIFICATION = 'VERIFICATION',
  DEFERRED_EMAIL_VERIFICATION = 'DEFERRED_EMAIL_VERIFICATION',
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  GROUP_MEMBER_LINK = 'GROUP_MEMBER_LINK',
  GROUP_MEMBER_LINK_CONFIRM = 'GROUP_MEMBER_LINK_CONFIRM',
  WORK_ARTIST_SEARCH = 'WORK_ARTIST_SEARCH',
  PROJECT_INFO_VENUE_SEARCH = 'PROJECT_INFO_VENUE_SEARCH',
  PROJECT_INFO_URL = 'PROJECT_INFO_URL',
  LANDING_MEMBER_SEARCH = 'LANDING_MEMBER_SEARCH',
  IMPORT_STATION_WORK = 'IMPORT_STATION_WORK',
  IMPORT_STATION_TEXT = 'IMPORT_STATION_TEXT',
  IMPORT_STATION_FOR_TEXT_BLOCK = 'IMPORT_STATION_FOR_TEXT_BLOCK',
  IMPORT_STATION_FOR_FORMATION_SLOT = 'IMPORT_STATION_FOR_FORMATION_SLOT',
  ORIGIN_IMG = 'ORIGIN_IMG',
  CHANGE_USERNAME = 'CHANGE_USERNAME',
  CHANGE_HANDLE = 'CHANGE_HANDLE',
  INDEXING = 'INDEXING',
  CHANGE_PW = 'CHANGE_PW',
  SET_PW = 'SET_PW',
  FIND_PW = 'FIND_PW',
  CHANGE_SHARE = 'CHANGE_SHARE',
  CHANGE_SEARCH_ENGINE = 'CHANGE_SEARCH_ENGINE',
  SUPPORT = 'SUPPORT',
  VENUE_REQUEST = 'VENUE_REQUEST',
  SUBSCRIPTION = 'SUBSCRIPTION',
  JOIN_WAITLIST = 'JOIN_WAITLIST',
  FILTER_STATION = 'FILTER_STATION',
  WORK_TAG_STATION = 'WORK_TAG_STATION',
  GROUP_MEMBER_TAG_STATION = 'GROUP_MEMBER_TAG_STATION',
  TEXT_TAG_STATION = 'TEXT_TAG_STATION',
  VENUE_TAG_STATION = 'VENUE_TAG_STATION',
  SELECT_WORK_TAG_MOBILE = 'SELECT_WORK_TAG_MOBILE',
  SELECT_EXHIBITION_TAG_MOBILE = 'SELECT_EXHIBITION_TAG_MOBILE',
  SELECT_GROUP_MEMBER_TAG_MOBILE = 'SELECT_GROUP_MEMBER_TAG_MOBILE',
  SELECT_TEXT_TAG_MOBILE = 'SELECT_TEXT_TAG_MOBILE',
  CREATE_WORK_TAG = 'CREATE_WORK_TAG',
  CREATE_GROUP_MEMBER_TAG = 'CREATE_GROUP_MEMBER_TAG',
  CREATE_TEXT_TAG = 'CREATE_TEXT_TAG',
  CREATE_VENUE_TAG = 'CREATE_VENUE_TAG',
  FILTER_STATION_MEMBER = 'FILTER_STATION_MEMBER',
  FILTER_STATION_VENUE = 'FILTER_STATION_VENUE',
  FILTER_STATION_EXHIBITION = 'FILTER_STATION_EXHIBITION',
  QR_GENERATOR = 'QR_GENERATOR',
  BULK_UPLOAD = 'BULK_UPLOAD',
  AGREE_POLICY = 'AGREE_POLICY',
  CREATE_CAREER_MOBILE = 'CREATE_CAREER_MOBILE',
  EDIT_PROJECT_INFO_MOBILE = 'EDIT_PROJECT_INFO_MOBILE',
  CREATE_PROJECT_ELEMENT_MOBILE = 'CREATE_PROJECT_ELEMENT_MOBILE',
  CREATE_PROJECT_PDF = 'CREATE_PROJECT_PDF',
  CREATE_WORK_PDF = 'CREATE_WORK_PDF',
  CREATE_ABOUT_PDF = 'CREATE_ABOUT_PDF',
  CREATE_FLOOR_PLAN = 'CREATE_FLOOR_PLAN',
}

export enum AlertType {
  NONE = 'NONE',
  ALERT = 'ALERT',
  CONFIRM = 'CONFIRM',
  EMERGENCY = 'EMERGENCY',
  MAINTENANCE = 'MAINTENANCE',
}
export enum AlertPosition {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER'
}

export enum TempAlertType {
  WELCOME = 'WELCOME',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
  PAYMENT_PROCESSING = 'PAYMENT_PROCESSING',
  PW_NOT_SET = 'PW_NOT_SET',
  UNAUTHORIZED_ACCESS = 'UNAUTHORIZED_ACCESS',
}

export enum TempAlertPosition {
  LT = 'LT',
  LC = 'LC',
  LB = 'LB',
  RT = 'RT',
  RC = 'RC',
  RB = 'RB',
  CC = 'CC'
}

export enum ProjectListType {
  CARD = 'CARD',
  TICKET = 'TICKET',
  STACKED = 'STACKED',
}

export enum WorkListType {
  LIST = 'LIST',
  GRID = 'GRID',
}

export const getNextWorkListType = (current: WorkListType): WorkListType =>
  current === WorkListType.GRID ? WorkListType.LIST : WorkListType.GRID;

export enum ProjectType {
  NONE = 'NONE',
  SOLO_EXHIBITION = 'SOLO_EXHIBITION',
  DUO_EXHIBITION = 'DUO_EXHIBITION',
  GROUP_EXHIBITION = 'GROUP_EXHIBITION',
  PROJECT = 'PROJECT',
  SERIES = 'SERIES',
  WORK = 'WORK',
  WORKSHOP = 'WORKSHOP',
}

export enum ProjectInfoType {
  ACTIVE_DATE = 'ACTIVE_DATE',
  LOCATION = 'LOCATION',
  CREDIT = 'CREDIT',
  OTHER = 'OTHER',
}

export enum ProjectElementType {
  WORK = 'WORK',
  DETAIL = 'DETAIL',
  DOCUMENT = 'DOCUMENT',
  PDF = 'PDF',
  TEXT = 'TEXT',
  TEXTBOX = 'TEXTBOX',
  FORMATION = 'FORMATION',
  DIVIDER = 'DIVIDER',
}

export enum CountryType {
  KR = 'KR',      //Korea
  US = 'US',      //United States
  CA = 'CA',      //Canada
  AU = 'AU',      //Australia
  UK = 'UK',      //United Kingdom
  NL = 'NL',      //Netherlands
  DE = 'DE',      //Germany
  FR = 'FR',      //France
  JP = 'JP',      //Japan
  CN = 'CN',      //China
  NONE = 'NONE'  // private or None selected
}

export interface Country {
  code: string;
  name: string;
  flag: string;
}

export interface Region {
  code: string;
  name: string;
}


export const COUNTRY_LIST: Country[] = [
  { code: 'US', name: 'United States', flag: '🇺🇸' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
  { code: 'FR', name: 'France', flag: '🇫🇷' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵' },
];

export enum CareerType {
  EDU = 'EDU',      //Education
  S_EXH = 'S_EXH',  //Solo Exhibition
  G_EXH = 'G_EXH',  //Group Exhibition
  BIEN_TRIEN = 'BIEN_TRIEN',  //Biennials/Triennials
  PRJ = 'PRJ',      //Project
  FAR = 'FAR',      //Art Fair
  PRZ = 'PRZ',      //Prize
  GRT = 'GRT',      //Grant
  PRS = 'PRS',      //Press
  RSD = 'RSD',      //Residency
  RPS = 'RPS',      //Representation
  COL = 'COL',      //Collections
  TCH = 'TCH',      //Teach
  EXP = 'EXP',      //Professional Experience
  RSH = 'RSH',      //Research
  WRT = 'WRT',      //Writing
  PBL = 'PBL',      //Publication
  CNS = 'CNS',      //Consulting
}

export enum CareerPeriodType {
  POINT = 'POINT',
  PERIOD = 'PERIOD'
}

export enum TextArea {
  WORK = 'WORK',
  TEXTBOX = 'TEXTBOX'
}

export enum DividerType {
  PLAIN = 'PLAIN',
  DOTTED = 'DOTTED',
  DASHED = 'DASHED',
}

export enum FormationType {
  TWO_COLUMNS = 'TWO_COLUMNS',
  // 구형 API/DB 값 호환용. 프런트에서는 FEATURE_SIDE로 정규화한다.
  FEATURE_TOP = 'FEATURE_TOP',
  FEATURE_SIDE = 'FEATURE_SIDE',
  THREE_COLUMNS = 'THREE_COLUMNS',
}

export enum FormationImageMode {
  FIT = 'FIT',
  FILL = 'FILL',
}

export enum FormationHorizontalAlignment {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

export enum FormationVerticalAlignment {
  TOP = 'TOP',
  CENTER = 'CENTER',
  BOTTOM = 'BOTTOM',
}


export enum SelectType {
  TEXT_ALIGNMENT = 'TEXT_ALIGNMENT',
  TEXT_BLOCK_TYPE = 'TEXT_BLOCK_TYPE',
  DISPLAY_ALIGNMENT = 'DISPLAY_ALIGNMENT',
  PE_INFO_TYPE = 'PE_INFO_TYPE',
  PROJECT_INFO_TYPE = 'PROJECT_INFO_TYPE',
  WORK_SIZE = 'WORK_SIZE',
  SORT_ORDER = 'SORT_ORDER',
  SORT_DIRECTION = 'SORT_DIRECTION',
  WORK_TYPE = 'WORK_TYPE',
  COUNTRY = 'COUNTRY',
  GROUP_MEMBER_ROLE = 'GROUP_MEMBER_ROLE',
  SIZE_UNIT = 'SIZE_UNIT',
  SIZE_RATIO = 'SIZE_RATIO',
  SYSTEM_ALERT_TYPE = 'SYSTEM_ALERT_TYPE',
  COVER_HEIGHT = 'COVER_HEIGHT',
  PROJECT_TYPE = 'PROJECT_TYPE',
  PER_PAGE = 'PER_PAGE',
  LANGUAGE = 'LANGUAGE',
  EXPOSURE_LEVEL = 'EXPOSURE_LEVEL',
  SUPPORT_TYPE = 'SUPPORT_TYPE',
  SUPPORT_AREA = 'SUPPORT_AREA',
}

export enum TextAlignment {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

export enum WorkType {
  PAINTING = 'PAINTING',
  DRAWING = 'DRAWING',
  PRINTS = 'PRINTS',
  PHOTO = 'PHOTO',
  DIGITAL = 'DIGITAL',
  INSTALLATION = 'INSTALLATION',
  SCULPTURE = 'SCULPTURE',
  CERAMIC = 'CERAMIC',
  TEXTILE = 'TEXTILE',
  CONCEPTUAL = 'CONCEPTUAL',
  VIDEO = 'VIDEO',
  PERFORMANCE = 'PERFORMANCE',
  BOOK = 'BOOK',
  NONE = 'NONE'
}

/** VIDEO·PERFORMANCE: size 대신 duration, 영상 URL·`WorkViewerVideo`와 동일하게 취급 */
export const usesWorkDuration = (workType: WorkType): boolean =>
  workType === WorkType.VIDEO || workType === WorkType.PERFORMANCE;

export enum DimensionsType {
  FIXED = 'FIXED',
  CUSTOM = 'CUSTOM',
  VARIABLE = 'VARIABLE',
  NONE = 'NONE'
}

export enum CurrencyCode {
  USD = 'USD',
  KRW = 'KRW',
  JPY = 'JPY',
  EUR = 'EUR',
  GBP = 'GBP',
  CNY = 'CNY',
  AUD = 'AUD',
  CAD = 'CAD',
  CHF = 'CHF',
  HKD = 'HKD',
  SGD = 'SGD',
  INR = 'INR',
  NZD = 'NZD',
}

// export enum DisplayAlignment {
//   LEFT_FLUSH = '││ㅁ│──────│',
//   LEFT_OFFSET = '│──│ㅁ│────│',
//   CENTER = '│───│ㅁ│───│',
//   RIGHT_OFFSET = '│────│ㅁ│──│',
//   RIGHT_FLUSH = '│──────│ㅁ││',
// }
export enum DisplayAlignment {
  LEFT_FLUSH = 'LEFT_FLUSH',
  LEFT_OFFSET = 'LEFT_OFFSET',
  CENTER = 'CENTER',
  RIGHT_OFFSET = 'RIGHT_OFFSET',
  RIGHT_FLUSH = 'RIGHT_FLUSH',
}

export enum DisplaySize {
  WIDE = 'WIDE',
  BIG = 'BIG',
  MEDIUM = 'MEDIUM',
  REGULAR = 'REGULAR',
  SMALL = 'SMALL'
}

export enum PEInfoType {
  INLINE = 'INLINE',
  NONE = 'NONE',
}

export const normalizePEInfoType = (infoType?: PEInfoType | string | null): PEInfoType =>
  infoType === PEInfoType.NONE ? PEInfoType.NONE : PEInfoType.INLINE;

export enum ImageStyle {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT'
}

export enum PerPage {
  PAGE_10 = '10',
  PAGE_20 = '20',
  PAGE_50 = '50',
}
// Convert PerPage enum to number
export const perPageToNumber = (perPage: PerPage): number => {
  return Number(perPage);
};

export enum WorkSortOrder {
  MANUAL_ORDER = 'manualOrder',
  ARTIST_NAME = 'artistName',
  TITLE = 'title',
  YEAR = 'prodYear',
}

export enum SupportSortOrder {
  TITLE = 'title',
  CREATED_AT = 'createdAt',
  STATUS = 'status',
}

export enum MemberSortOrder {
  USERNAME = 'username',
  LAST_LOGIN_AT = 'lastLoginAt',
  MEMBER_STATUS = 'memberStatus',
  SUBSCRIPTION_STATUS = 'subscriptionStatus',
}

export enum MaterialAliasSortOrder {
  KEYWORD = 'keyword',
  FREQUENCY = 'frequency',
}

export enum VenueSortOrder {
  NAME = 'name',
}

export enum MemberType {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
}

export enum ArchiveRole {
  ARTIST = 'ARTIST',
  CURATOR = 'CURATOR',
  RESEARCHER = 'RESEARCHER',
  EDUCATOR = 'EDUCATOR',
}

export enum SignupArchiveType {
  ARTIST = 'ARTIST',
  CURATOR = 'CURATOR',
  RESEARCHER = 'RESEARCHER',
  EDUCATOR = 'EDUCATOR',
  GROUP = 'GROUP',
}

export enum GroupMemberStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum GroupMemberRole {
  ARTIST = 'ARTIST',
  CURATOR = 'CURATOR',
  RESEARCHER = 'RESEARCHER',
  PRODUCER = 'PRODUCER',
  EDUCATOR = 'EDUCATOR',
}

export enum SubscriptionStatus {
  TRIALING = 'TRIALING',
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum ServiceType {
  BILLBOARD = 'BILLBOARD',
  WORK = 'WORK',
  DETAIL = 'DETAIL',
  DOCUMENT = 'DOCUMENT',
  PDF = 'PDF',
  PROJECT = 'PROJECT',
  MEMBER_INFO = 'MEMBER_INFO',
  SEO = 'SEO',
  /** Text 본문 내 이미지 블록 */
  TEXT_BLOCK = 'TEXT_BLOCK',
  FORMATION = 'FORMATION',
}

export const BREAKPOINTS = {
  MOBILE: 767,    // 0 - 767px
  TABLET: 1024,   // 768px - 1024px
  LAPTOP: 1920,   // 1025px - 1920px (일반 노트북 포함)
  DESKTOP: 2560,  // 1921px - 2560px (4K까지 포함)
};

export enum DeviceType {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  LAPTOP = 'LAPTOP',
  DESKTOP = 'DESKTOP'
}

export enum SupportStatus {
  PENDING = 'PENDING',
  DISMISSED = 'DISMISSED',
  IN_PROCESS = 'IN_PROCESS',
  SOLVED = 'SOLVED',
}

export enum SupportType {
  VENUE_REQUEST = 'VENUE_REQUEST',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  BUG_REPORT = 'BUG_REPORT',
  INCONVENIENCE = 'INCONVENIENCE',
  BILLING = 'BILLING',
  OPERATIONS = 'OPERATIONS',
  OTHER = 'OTHER',
}

export enum SupportArea {
  LANDING = 'LANDING',
  BILLBOARD = 'BILLBOARD',
  PROJECTS = 'PROJECTS',
  WORKS = 'WORKS',
  TEXTS = 'TEXTS',
  ABOUT = 'ABOUT',
  CONTACT = 'CONTACT',
  EXHIBITION = 'EXHIBITION',
  GUIDE = 'GUIDE',
  OTHERS = 'OTHERS',
}



export enum SizeUnit {
  // METER = 'M',
  CM = 'CM',
  IN = 'IN',
  FT = 'FT',
  PX = 'PX'
}

// SizeUnit의 표시용 값들을 반환하는 함수
export const getSizeUnitDisplayValue = (unit: SizeUnit): string => {
  const displayMap = {
    // [SizeUnit.METER]: 'm',
    [SizeUnit.CM]: 'cm',
    [SizeUnit.IN]: 'in',
    [SizeUnit.FT]: 'ft',
    [SizeUnit.PX]: 'px',
  };
  return displayMap[unit];
};


export enum BillingFieldState {
  REQUIRED = 'required',
  OPTIONAL = 'optional',
  DISABLED = 'disabled'
}

export enum SizeRatio {
  LANDSCAPE = 'Landscape',
  PORTRAIT = 'Portrait',
  SQUARE = 'Square',
  NONE = 'None'
}

export enum SystemAlertType {
  INFO = 'INFO',
  EMERGENCY = 'EMERGENCY',
  MAINTENANCE = 'MAINTENANCE',
}

export enum Language {
  KR = 'KR',
  EN = 'EN',
  // JA = 'JA',
  // ZH = 'ZH',
}

export const SUPPORT_TYPE_LABELS: Record<SupportType, Record<Language, string>> = {
  [SupportType.VENUE_REQUEST]: { [Language.KR]: '전시·공간 등록 요청', [Language.EN]: 'Exhibition·Venue' },
  [SupportType.FEATURE_REQUEST]: { [Language.KR]: '새로운 기능 요청', [Language.EN]: 'Feature request' },
  [SupportType.BUG_REPORT]: { [Language.KR]: '오류 신고', [Language.EN]: 'Bug report' },
  [SupportType.INCONVENIENCE]: { [Language.KR]: '불편함 신고', [Language.EN]: 'Inconvenience' },
  [SupportType.BILLING]: { [Language.KR]: '결제/구독', [Language.EN]: 'Billing' },
  [SupportType.OPERATIONS]: { [Language.KR]: '운영/정책', [Language.EN]: 'Operations' },
  [SupportType.OTHER]: { [Language.KR]: '기타', [Language.EN]: 'Other' },
};

export const getSupportTypeLabel = (type: SupportType, language: Language): string =>
  SUPPORT_TYPE_LABELS[type][language];

export const SUPPORT_AREA_LABELS: Record<SupportArea, Record<Language, string>> = {
  [SupportArea.LANDING]: { [Language.KR]: 'Landing', [Language.EN]: 'Landing' },
  [SupportArea.BILLBOARD]: { [Language.KR]: 'Billboard', [Language.EN]: 'Billboard' },
  [SupportArea.PROJECTS]: { [Language.KR]: 'Projects', [Language.EN]: 'Projects' },
  [SupportArea.WORKS]: { [Language.KR]: 'Works', [Language.EN]: 'Works' },
  [SupportArea.TEXTS]: { [Language.KR]: 'Texts', [Language.EN]: 'Texts' },
  [SupportArea.ABOUT]: { [Language.KR]: 'About', [Language.EN]: 'About' },
  [SupportArea.CONTACT]: { [Language.KR]: 'Contact', [Language.EN]: 'Contact' },
  [SupportArea.EXHIBITION]: { [Language.KR]: 'Exhibition', [Language.EN]: 'Exhibition' },
  [SupportArea.GUIDE]: { [Language.KR]: 'Guide', [Language.EN]: 'Guide' },
  [SupportArea.OTHERS]: { [Language.KR]: '기타', [Language.EN]: 'Others' },
};

export const getSupportAreaLabel = (area: SupportArea, language: Language): string =>
  SUPPORT_AREA_LABELS[area][language];

/** About 페이지 콘텐츠 조회: 원문 필드(content) vs 영문 필드(contentEn). 전역 Language와 무관 */
export enum AboutContentMode {
  Orig = 'Orig',
  ENG = 'ENG',
}

/** Works·Project Work 표시: 원문 vs titleEn/materialEn/descriptionEn. AboutContentMode와 분리 */
export enum WorkContentMode {
  Orig = 'Orig',
  ENG = 'ENG',
}

export enum GroupMemberContentMode {
  Orig = 'Orig',
  ENG = 'ENG',
}

/** About CV PDF보내기: 세로 / 가로 A4 */
export enum PdfLayout {
  Vertical = 'Vertical',
  Horizontal = 'Horizontal',
}

export enum ExportFormat {
  PDF = 'PDF',
  XLSX = 'XLSX',
}

export enum PollQuestionType {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
  TEXT = 'text',
}

export enum CoverHeight {
  FULL = 'FULL',
  HALF = 'HALF',
}

export enum OnBoardingStepType {
  URL = 'url',
  EMAIL = 'email',
  ACTIVITY_TYPE = 'activity_type',
  UPLOAD_WORKS = 'upload_works',
  WORKS_PREVIEW = 'works_preview',
  // ============================== Project ==============================
  // PROJECT_INFO = 'project_info',
  // PROJECT_WORKS = 'project_works',
  // PROJECT_PREVIEW = 'project_preview',
}

export enum DeferredType {
  WORK = 'WORK',
  PROJECT = 'PROJECT',
}

export enum PasswordStatus {
  NOT_SET = 'NOT_SET',
  OK = 'OK',
}

/**
 * Setting.exposureLevel — 백엔드 `ExposureLevel` 과 동일
 * PRIVATE(accessible=false, searchable=false, recommendable=false)
 * SEARCHABLE(accessible=true, searchable=true, recommendable=false)
 * PUBLIC(accessible=true, searchable=true, recommendable=true)
 */
export enum ExposureLevel {
  PRIVATE = 'PRIVATE',
  SEARCHABLE = 'SEARCHABLE',
  PUBLIC = 'PUBLIC',
}

/**
 * Setting.navLayout — 백엔드 `NavLayout` 과 동일
 * FOLD: 호버로 열렸다 닫히는 왼쪽 메뉴
 * FIXED: 항상 보이는 왼쪽 메뉴
 */
export enum NavLayout {
  FOLD = 'FOLD',
  FIXED = 'FIXED',
}

export enum TextBlockType {
  HEADING = 'HEADING',
  PARAGRAPH = 'PARAGRAPH',
  QUOTE = 'QUOTE',
  IMAGE = 'IMAGE',
  SOURCE_LINE = 'SOURCE_LINE',
  LINK = 'LINK',
}

export enum TextSortOrder {
  MANUAL_ORDER = 'manualOrder',
  TITLE = 'title',
  YEAR = 'prodYear',
}

export enum DetailType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

/** 전시가 열리는 물리적 공간 유형 */
export enum VenueType {
  ART_MUSEUM = 'ART_MUSEUM',
  GALLERY = 'GALLERY',
  ALTERNATIVE_SPACE = 'ALTERNATIVE_SPACE',
  ART_CENTER = 'ART_CENTER',
  CULTURAL_COMPLEX = 'CULTURAL_COMPLEX',
  PROJECT_SPACE = 'PROJECT_SPACE',
  OTHER = 'OTHER',
}

/** 공간의 장기 상태. 오늘 개점 여부가 아님 */
export enum VenueLifecycleStatus {
  ACTIVE = 'ACTIVE',
  TEMPORARILY_CLOSED = 'TEMPORARILY_CLOSED',
  PERMANENTLY_CLOSED = 'PERMANENTLY_CLOSED',
}

export enum VenueAdmissionType {
  FREE = 'FREE',
  PAID = 'PAID',
  VARIES = 'VARIES',
  UNKNOWN = 'UNKNOWN',
}

export enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}
